export default "__VITE_ASSET__DznP1ulk__"